<script>
    let { children } = $props();
</script>

<div class="tabs is-boxed">
    <ul>
	    {@render children?.()}
    </ul>
</div>
